import './style.css'
import * as THREE from 'three'


// Canvas
const canvas = document.querySelector('canvas.webgl');

// Scene
const scene = new THREE.Scene();

//size
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight 
}

window.addEventListener('resize', () =>
{
// Update sizes
    sizes.width = window.innerWidth;
    sizes.height = window.innerHeight;

// Update camera
    camera.aspect = sizes.width / sizes.height;
    camera.updateProjectionMatrix();

    // Update renderer
    renderer.setSize(sizes.width, sizes.height);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
})

// Base camera
let fov = Math.PI/2;
let CameraZ = (sizes.height/1.0)/Math.tan(fov/2.0);
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1,1000)
camera.position.set(0,0,5);

//Lights
const ambientLight = new THREE.AmbientLight(0xFFC18D, 0.1);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
directionalLight.position.set(0, 0, 2); // Initial light position
scene.add( directionalLight);


//shadows
directionalLight.castShadow = true;
directionalLight.shadow.camera.near =3500;
directionalLight.shadow.camera.far = 5000;

//Render
const renderer = new THREE.WebGLRenderer({
    canvas: canvas
})
renderer.shadowMap.enabled = true;
renderer.shadowMap.type = THREE.PCFSoftShadowMap;
renderer.setSize(sizes.width, sizes.height);
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

//code
const cubes = [];

for (let i = 0; i < 100; i++) {
  const size = i * 1.1 / 20;
  const geometry = new THREE. BoxGeometry(size, size, size);
  const hue = (i / 200) * 360; // Transition from red (0) to purple (300) in HSL color space
  const material = new THREE.MeshPhongMaterial({
    color: new THREE.Color(`hsl(${hue}, 100%, 50%)`),
    wireframe: true,
  });

  const cube = new THREE.Mesh(geometry, material);
  cube.rotation.x = Math.PI * 1 / 2;
  cube.rotation.y = (Math.PI * i * 8.2) / 360;
  cube.rotation.z = (Math.PI * i * 10) / 360;
  scene.add(cube);
  cubes.push(cube);
}
document.addEventListener('mousemove', (event) => {
  const mouseX = (event.clientX / window.innerWidth) * 2 - 1;
  const mouseY = -(event.clientY / window.innerHeight) * 2 + 1;

  // Spread out the cubes based on mouse position
  cubes.forEach((cube, i) => {
    const offset = i * 0.1;
    cube.position.x = mouseX * offset;
    cube.position.y = mouseY * offset;
  });
});

let lightAngle = 0;
let lightColorHue = 0;

//animation
        const AniClock = new THREE.Clock();
        const Animate = () =>
        {
            const elapse = AniClock.getElapsedTime();
            // dome.rotation.z = 0.06* elapse;


   
            directionalLight.position.copy(camera.position);
            directionalLight.lookAt(scene.position);

            scene.traverse((object) => {
                if (object instanceof THREE.Mesh) {
                  object.rotation.x += 0.01;
                  object.rotation.y += 0.01;
                }
              }
              );

            // Update light position to create a spinning effect
            const radius = 2;
            directionalLight.position.x = radius * Math.cos(lightAngle);
            directionalLight.position.y = radius * Math.sin(lightAngle);

            
            
            // Update light color
            lightColorHue += 1;
            directionalLight.color.set(`hsl(${lightColorHue}, 100%, 50%)`);
            lightAngle += 0.005; // Adjust the rotation speed as needed



            renderer.render(scene, camera);
            window.requestAnimationFrame(Animate);
        }
        Animate();
